APP.joinCampaign = function () {
  $('.campaign-button',APP.context).click(function () {
    let campaign = $(this).closest('.campaign-item');
    let gift = $('.product-list',campaign);
    let popup_content = $('.popup-content ',campaign);
    let popup_detail = $('.popup-campaign-detail');
    let tnc_content = $('.tnc-content ',campaign);
    let popup_tnc = $('.popup.tnc');
    if ($('.popup-title', popup_content).length) {
      $('.popup-title', popup_detail).html($('.popup-title', popup_content).html());
    } else {
      $('.popup-title', popup_detail).html('<p>Mẹ vui mua sắm<br>Bé nhận quà xinh!</p>');
    }
    if ($('.popup-desc', popup_content).length) {
      $('.txt__warning', popup_detail).html($('.popup-desc', popup_content).html());
    } else {
      $('.txt__warning', popup_detail).html('<p>Đừng bỏ lỡ cơ hội trúng quà cực chất cho bé yêu khi mua các sản phẩm của Nestlé mẹ nhé!</p>');

    }
    $('.txt__warning', popup_tnc).html(tnc_content.html());
    $('.product-list',popup_detail).html(gift.html());
    
    $('.section__additional input[name="campaign_code"]').val($(this).attr("data-bu"));
    $('.section__additional input[name="node_id"]').val($(this).attr("data-cid"));
    $('.section__additional input[name="node_id"]').trigger('change');
    popup_detail.addClass('show');


  });
  $('.join-campaign',APP.context).click(function () {
    $('.section').removeClass('active');
    $('.section__additional').addClass('active');
    $('#odc-additional-form-button-topup').attr('type','button');
    $('.popup').removeClass('show');
    // Re-run datepicker to show datepicker
    APP.datepicker();
  });
};
